import { OPEN_SIDEVIEW } from '../constants'

export default channel => ({
    type: OPEN_SIDEVIEW,
    channel
})
